// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"6beb3788","316":"2a671a03","322":"c85dd00e"}[chunkId] + ".chunk.js";
};